module.exports = __webpack_public_path__ + "fonts/TheFontGatsby.f53c2391.woff";